import "./FlowReviewField.scss";

import { ComponentProps } from "react";

import Icon from "components/Icon/Icon";
import Text from "components/Text/Text";
import { DynamicFormInputItems } from "config";

import classNames from "classnames";

import { FlowReviewAnswerList, FlowReviewAnswerText } from "./FlowReviewAnswers";

interface IProps {
  inputType: DynamicFormInputItems["type"];
  isEditDisabled: boolean;
  label: DynamicFormInputItems["content"]["label"];
  value: string | string[];
  options?: {
    label: string;
    value: string;
  }[];
  unit?: string;
  onEdit(): void;
}

type TAnswerType =
  | ComponentProps<typeof FlowReviewAnswerText>["type"]
  | ComponentProps<typeof FlowReviewAnswerList>["type"]
  | null;

function getAnswerType(inputType: DynamicFormInputItems["type"]): TAnswerType {
  switch (inputType) {
    case "inputSingleSelect":
      return "boolean";

    case "inputMultiSelect":
      return "list";

    case "inputNumeric":
      return "numeric";

    case "inputText":
      return "long_text";

    case "inputUnitized":
      return "unitized";

    default:
      return null;
  }
}

const FlowReviewField = (props: IProps) => {
  const { inputType, label, isEditDisabled, onEdit, options = [], unit, value } = props;

  const answerType = getAnswerType(inputType);
  const iconClasses = classNames("flow-review-field__edit-btn", {
    "flow-review-field__edit-btn--disabled": isEditDisabled,
  });

  return (
    <div className="flow-review-field">
      <div className="flow-review-field__header">
        <Text className="flow-review-field__label" tag="l6" text={label} />
        <Icon className={iconClasses} onClick={onEdit} size="sm" src="edit" />
      </div>

      {answerType === "boolean" || answerType === "list" ? (
        <FlowReviewAnswerList options={options} type={answerType} value={value} />
      ) : null}

      {answerType === "long_text" || answerType === "numeric" || answerType === "unitized" ? (
        <FlowReviewAnswerText options={options} type={answerType} unit={unit} value={value} />
      ) : null}
    </div>
  );
};

export default FlowReviewField;
